import { render, staticRenderFns } from "./InventoryCostReportTable.vue?vue&type=template&id=66a9ad50"
import script from "./InventoryCostReportTable.vue?vue&type=script&lang=js"
export * from "./InventoryCostReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports